import React, { FC, useState, useRef, useEffect } from 'react'
import Frame from 'components/Frame'
import styled from 'styled-components'
import { useHistory } from "react-router-dom";
import BG from 'assets/img/upload/BG.png'
import { inject, observer } from 'mobx-react';
import Clip from 'assets/img/upload/ic_attachment_24px.svg'
import Cloud from 'assets/img/upload/ic_cloud_upload_24px.svg'
import fonts from 'const/style/fonts';
import Modal from 'components/Modal';
import colors from 'const/style/colors';
import CloudDone from 'assets/icon/ic_cloud_done_24px.svg'
import FileUpload from 'models/FileUpload';
import Spinner from 'components/Spinner';
import IconJobFlex from 'assets/icon/ic_jobflex_white.png'
import Footer from 'components/Footer';
import ApplicantInfoView from 'components/ApplicantInfoView';
import UserStatusType from 'consts/UserStatusType';
import Login from 'models/Login';
import Presentation from 'models/Presentation';
import ProgressBar from "../components/ProgressBar";
const FileUploadPageFrame = styled(Frame)`
    background-image: url(${BG});
    background-size:100% 100%;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
   
   .frame{
        width:100%;
        display:flex;
        flex-direction:column;
        justify-content:center;
        align-items:center;
        .cloud{
        width: 165px;
        height: 110px;
        opacity: 1;
        margin-bottom:35px;
        }

        H1{
            ${fonts.H1_White};
        }
        H2{
            ${fonts.H2_White};
            font-weight: 400;
        }
        B{
            font-weight: 700;
        }

        .search-file-btn{
            margin-top:60px;
            width: 200px;
            height: 40px;
            background: #FFFFFF 0% 0% no-repeat padding-box;
            border-radius: 5px;
            opacity: 1;
        
            div{
                display:flex;
                flex-direction:row;
                justify-content:center;
                align-items:center;
                font-weight:bold;
                font-size:18px;
                margin-right: 5px;
                img{
                    margin-right:5px;
                }
            }
         }

   

        .next-btn{
            background: #2E303C 0% 0% no-repeat padding-box;
            border-radius: 5px;
            opacity: 1;
            width: 200px;
            height: 40px;
            font-size:18px;
            color:white;
            :disabled {
                        visibility:hidden;
                    }
        }
        .frame-file-div{
            color:white;
            background: #FFFFFF2A 0% 0% no-repeat padding-box;
            border-radius: 5px;
            display:flex;
            flex-direction:row;
            align-items:center;
            justify-content:space-between;
            margin-top:20px;
            padding:5px 5px 5px 20px;
            h2 {
             margin-left: 15px;
            }
            button{
           
           margin-left: 15px;
            width: 200px;
            height: 40px;
            background: #FFFFFF 0% 0% no-repeat padding-box;
            border-radius: 5px;
            opacity: 1;
            font-weight:bold;
            font-size:18px;
        
            }
        }
    }
    #file-pdf {
        display:none;
    }
    button label {
        display:flex;
        width:100%;
        height:100%;
        flex-direction:row;
        justify-content:center;
        align-items:center;
    }

    .frame-footer {
     position:fixed;
     bottom:0;
  }
`

const PreViewFrame = styled.div`
    /* margin-top:10vh;
    margin-bottom:50px; */

    @media only screen and (min-height:0px) {
    margin-top:15px;
    margin-bottom:10px;
    }

    @media only screen and (min-height:768px) and (max-height:1079px) {
    margin-top:50px;
    margin-bottom:40px;
    }

    @media only screen and (min-height:1080px) {
    margin-top:85px;
    margin-bottom:95px;
    }

    width:70%;
    padding:20px 0px 5px 0px;
    background:transparent;
    overflow-x:scroll;
    white-space:nowrap;

    &::-webkit-scrollbar:horizontal
    {
        height:7px;
        background-color:  transparent;
    }

    &::-webkit-scrollbar-track {
    background-color:  rgba(0,0,0,0.4);
    }
    &::-webkit-scrollbar-track:horizontal:hover {
    background-color:  rgba(0,0,0,0.4);
    }
    &::-webkit-scrollbar-thumb
    {
    width: 350px;
    background-color: rgba(255,255,255);
    border-radius: 8px;
    }
    &::-webkit-scrollbar-thumb:horizontal:hover
    {
    width: 350px;
    background-color: #CACACA;
    border-radius: 8px;
    }

 
    .ol-thumbs {
        counter-reset: slide;
        li {
        display:inline-flex;
        flex-direction:row;
        position:relative;
        padding-right:24px;
        margin-bottom:1rem;
        cursor:pointer;
        &:before {
          ${fonts.presentation_thumb_number};
          color:white;
          position:absolute;
          top:-20px;
          left:0px;
          min-width:12px;
          overflow-x:visible;
          text-align:center;
          counter-increment:slide;
          content:counter(slide) ${(props) => `"/${(props as any)['data-total-page']}"`};
          
        }
      }
      .slide-thumb {
        width:463px;
        min-height: 346px;
        background:${colors.CF7F7F7};
        border: 1px solid ${colors.CCCCCCC};
        display:flex;
        justify-content:center;
        align-items:center;
        &.selected {
          border: 3px solid ${colors.C000000};
        }
        img{
          width:95%;
          height:100%;
          position:absolute;
          object-fit:contain;
        }
      }
    }
`

interface IFileUploadPageProp {
    fileUpload?: FileUpload;
    loginInfo?: Login;
    presentation?: Presentation;
}




const FileUploadPage: FC<IFileUploadPageProp> = (props: IFileUploadPageProp) => {
    const { loginInfo, fileUpload, presentation = new Presentation() }: IFileUploadPageProp = props;
    const history = useHistory();
    const refPreViewDiv = useRef<HTMLDivElement>(null);

    const [isNextCheck, setIsNextCheck] = useState<boolean>(false);
    // const [isFileUpload, setIsFileUpload] = useState<boolean>(false);

    const refInputFile = useRef<HTMLInputElement>(null);

    const nextClick = async (data: any) => {
        await loginInfo?.updateNow();
        if(!loginInfo?.ptCountCheck)
            return;
        presentation.slides = fileUpload?.slides || [];
        if (isNextCheck) {
            if(loginInfo.userInfo)
                loginInfo.userInfo.userStatusType = UserStatusType.PDF_UPLOAD;
            history.push("/presentation");
        }
        else setIsNextCheck(true);
        setIsNextCheck(true)
    };
    const slideRight = (data: any) => {
        // if(refPreViewDiv.scrollLeft!=null) return;
        if (!refPreViewDiv.current) return;
        if (data.deltaY < 0) refPreViewDiv.current.scrollLeft -= window.innerWidth*0.07;
        else refPreViewDiv.current.scrollLeft += window.innerWidth*0.07;
    }
    const audio_first = async() => {
        await loginInfo!.getTTS(`프레젠테이션에 사용할 발표자료를 업로드하세요.`);
        let audio = new Audio(`${loginInfo?.URL_TTS}${loginInfo!.audio}`);
        audio.play();
    }
    const audio_second = async() => {
        await loginInfo!.getTTS(`발표자료가 정상적으로 업로드되었습니다. 발표자료가 잘못 업로드된 경우 파일 변경 버튼을 클릭하여 다시 업로드하세요.`);
        let audio = new Audio(`${loginInfo?.URL_TTS}${loginInfo!.audio}`);
        audio.play();
    }


    if (!fileUpload)
        throw new Error('no fileupload Found');

    useEffect(() => {
        
        if(fileUpload?.isFileUpload)audio_second();
    }, [fileUpload?.isFileUpload])

    useEffect(()=>{
        audio_first();
    },[]);

    return (
        <FileUploadPageFrame>
             <img className='jobflex-logo' src={IconJobFlex}></img>
             <ApplicantInfoView></ApplicantInfoView>
             <input 
                ref={refInputFile}
                type='file' 
                accept='.pdf' 
                id='file-pdf' 
                onChange={ async (event: any)=>{
                    await fileUpload.onPdfFileChange(event);
                    if(fileUpload!.isFileUpload)
                    await loginInfo!.updateUserStatusType(UserStatusType.PDF_UPLOAD);
                    if(refInputFile.current)
                        refInputFile.current.value = '';
                }}
             />
             {!fileUpload.isFileUpload ?
                    <div className="frame">
                    <img className="cloud" src={Cloud}></img>
                    <h1>프레젠테이션에 사용할 발표자료를 업로드하세요.</h1>
                    <h2>발표자료의 용량이 크거나 자료 내 삽입된 이미지가 무거운 경우,</h2>
                    <h2>발표자료 업로드와 다운로드의 소요 시간이 <b>최대 2분</b>까지 길어질 수 있습니다.</h2>
                    <h2>발표자료는 <b>10MB 이하 용량의 PDF 파일</b>로 준비해 주세요.</h2>
                        <button className="search-file-btn" >
                        <label htmlFor='file-pdf'>
                            <div><img src={Clip}></img><div>파일 찾기</div></div>
                        </label>
                    </button>
                </div>
                :
                <div className="frame">
                    <h1>발표자료가 정상적으로 업로드되었습니다.</h1>
                    <h1>발표자료가 잘못 업로드된 경우 [파일 변경] 버튼을 클릭하여 다시 업로드하세요.</h1>
                    <div className='frame-file-div'>
                        <img src={CloudDone}></img>
                        <h2>{fileUpload.fileName}</h2>
                        <button type='button'>
                            <label htmlFor='file-pdf'>
                                파일 변경
                            </label>
                        </button>
                    </div>
                    <PreViewFrame
                        onWheel={slideRight as any}
                        ref={refPreViewDiv}
                        data-total-page={fileUpload.slides.length}
                    >

                        <ol className='ol-thumbs'>
                            {
                                fileUpload.slides.map((slide, slideIdx) => (
                                    <li
                                        key={`slide-thumb-${slideIdx}`}
                                    // onClick={() => addHistory(thumbIdx)}
                                    >
                                        <div className={`slide-thumb`}>
                                            <img src={slide} alt={`슬라이드 #${slideIdx + 1}`} />
                                        </div>
                                    </li>
                                ))
                            }
                        </ol>

                    </PreViewFrame>

                    <button className='next-btn' onClick={nextClick}>다음 화면으로 이동</button>
                   
                </div>

            }
            <Modal open={fileUpload.isBlock}>
                <h1>{fileUpload.errorMsg}</h1>
                <button className="btn-cta" onClick={() => fileUpload.isBlock = false}>확인</button>
            </Modal>
            {
                fileUpload?.isLoading &&
                <ProgressBar leftText={"PDF 업로드"}
                             rightText={`${fileUpload?.loadingPage}/${fileUpload?.totalPage}`}
                             percentage={Math.floor((fileUpload?.loadingPage / fileUpload?.totalPage) * 100)}/>
            }
            <Modal open={isNextCheck}>
                        <h2 className='black'>다음 화면으로 이동한 후에는 발표자료를 변경할 수 없습니다.<br/>다음 화면으로 이동하시겠습니까?</h2>
                        <button className="btn-cta2" onClick={nextClick}>다음 화면으로 이동</button>
                        <button className="btn-cta" onClick={() => setIsNextCheck(false)}>발표자료 다시 확인</button>
                    </Modal>
                    <Footer />
        </FileUploadPageFrame>
    )

}

export default inject('loginInfo','fileUpload', 'presentation')(observer(FileUploadPage));